import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { CHECK_AUTH } from './actions.type'
import { SET_AUTH, SET_AUTH_ERROR } from './mutations.type'

const state = {
	userAuthenticated: null,
	roles: [],
	errors: null
}

const getters = {
	hasRole: (state) => (role) => {
		return state.roles.find(r => r === role) ? true	: false
	},
	hasRoles: (state, getters) => (roles) => {
		if (state.roles.length === 0) {
			return false
		}

		roles.forEach((role) => {
			if (!getters.hasRole(role))
				return false;
			})

		return true;
	},
	userAuthenticated (state) {
		return state.userAuthenticated;
	},
	isAuthenticated (state) {
		return state.userAuthenticated ? true : false
	}
}

const actions = {
	[CHECK_AUTH] (context, params) {
		return new Promise((resolve, reject) => {
			ApiService.get(CHECK_AUTH)
			.then(({data}) => {
				if (typeof data != 'object') {
					data = { user: null, roles: [] }
				}
				context.commit(SET_AUTH, data)
				resolve(data);
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_AUTH_ERROR, context, error)
				resolve();
			})
		})
	}
}

const mutations = {
	[SET_AUTH_ERROR] (state, error) {	
		state.userAuthenticated = null
		state.roles = []
		state.errors = error
	},
	[SET_AUTH] (state, data) {
		state.userAuthenticated = data.user
		state.roles = data.roles
		state.errors = null
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/auth.module.js